// extracted by mini-css-extract-plugin
export default {"form":"StatisticAdmin_form__S3AKI","item":"StatisticAdmin_item__7RqqW","error":"StatisticAdmin_error__VMEnL"};